module.exports = __webpack_public_path__ + "img/010_ZeichnerIn_EFZ_JR.f55681ce.jpg";